export const ACCESS_TOKEN_KEY = 'UNSAFE_pccAccessToken';
export const CAMPAIGN_MAX_SIZE = 12;
export const CAMPAIGN_CARD_IMAGE_ASPECT_RATIO_PC = '880 / 340';
export const CAMPAIGN_CARD_IMAGE_ASPECT_RATIO_SP = '750 / 304';
export const DEFAULT_PAGE_SIZE = 20;
export const FINGERPRINT = 'fingerprint';
export const JAPANESE_DATE_TIME_FORMAT = 'YYYY年MM月DD日(ddd)HH:mm';
export const JAPANESE_DATE_TIME_FORMAT_NO_PADDING = 'YYYY年M月D日(ddd)HH:mm';
export const JAPANESE_DATE_FORMAT = 'YYYY年MM月DD日';
